import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c614d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-delete-popup-box" }

import {computed} from 'vue';
import {Popup} from 'vant';
import {usePopReturn} from '@/hooks/usePopReturn';


const __default__ = {
  name: 'CommentDeletePopup'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    manageText: null,
    isShowPopup: { type: Boolean },
    handleManage: null,
    hidePopup: null
  },
  setup(__props: any) {

const props = __props as {
  manageText: string;
  isShowPopup: boolean;
  handleManage:() => void;
  hidePopup: () => void;
}



const isShowPopupDraft = computed({
  get() {
    return props.isShowPopup;
  },
  set(val:boolean) {
    props.hidePopup();
  },
});

const {handleClose, handleOpen} = usePopReturn(isShowPopupDraft, props.hidePopup);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popup), {
    show: _unref(isShowPopupDraft),
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isShowPopupDraft) ? (isShowPopupDraft).value = $event : null)),
    teleport: ".detail-page",
    round: "",
    position: "bottom",
    onOpen: _unref(handleOpen),
    onClose: _unref(handleClose)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "manage-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleManage && __props.handleManage(...args)))
        }, _toDisplayString(__props.manageText), 1),
        _createElementVNode("footer", {
          class: "cancel-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (__props.hidePopup && __props.hidePopup(...args)))
        }, " 取消 ")
      ])
    ]),
    _: 1
  }, 8, ["show", "onOpen", "onClose"]))
}
}

})